import { ref } from "vue";
import { Browser } from "@capacitor/browser";
import { useAuth0 } from "@auth0/auth0-vue";
import { useRoute } from "vue-router";
import { getLoginPathObj } from "@/utils/redirect-uri";

/**
 * Composable for handling Auth0 login with in-app browser
 * @param {Object} options - Configuration options
 * @param {boolean} options.useDeepLink - Whether to use deepLinkPathObj from sessionStorage (default: false)
 * @returns {Object} Login function and browser state
 */
export function useAuthLogin(options = {}) {
  const { useDeepLink = false } = options;
  const { loginWithRedirect } = useAuth0();
  const route = useRoute();
  const isBrowserOpen = ref(false);

  const login = async () => {
    let appState = {};

    if (useDeepLink) {
      // Use deepLinkPathObj from sessionStorage (for login/index.vue)
      const deepLinkPathObjString = sessionStorage.getItem("deepLinkPathObj");
      const deepLinkPathObj = deepLinkPathObjString
        ? JSON.parse(deepLinkPathObjString)
        : null;
      appState = {
        target: "/home",
        fullPathObj: deepLinkPathObj,
      };
    } else {
      // Use loginPathObj from sessionStorage (for index.vue)
      const loginPathObj = getLoginPathObj();
      appState = {
        fullPathObj: loginPathObj,
      };
    }

    const config = {
      appState,
      openUrl: async (url) => {
        console.log("Opening Auth0 login in in-app browser:", url);
        await Browser.open({
          url,
          windowName: "_self",
        });
        isBrowserOpen.value = true;
      },
    };

    // Add login_hint if present in route query
    if (route.query.login_hint) {
      config.authorizationParams = {
        login_hint: route.query.login_hint,
      };
    }

    await loginWithRedirect(config);
  };

  return {
    login,
    isBrowserOpen,
  };
}

